









import Vue from 'vue'

export default Vue.extend({
  name: "admin-users-page",

  data() {
    return {
      users: [] as any[]
    }
  },

  computed: {
    
  },

  methods: {
    getUsers() {
      const users:any[] = []
      if (this.$store.state.user.userType == "partner") {
        this.$db.collection('users')
        .where('partners', 'array-contains', this.$store.state.user.partners[0])
        .onSnapshot(snapshot => {
          if (snapshot.size) {
            snapshot.forEach(doc => {
              users.push({_id: doc.id, ...doc.data()})
            })
          }
        })
      } else if (this.$store.state.user.userType == "client") {
        this.$db.collection('users')
        .where('clients', 'array-contains', this.$store.state.user.clients[0])
        .onSnapshot(snapshot => {
          if (snapshot.size) {
            snapshot.forEach(doc => {
              users.push({_id: doc.id, ...doc.data()})
            })
          }
        })
      } else if (this.$store.state.user.userType == "super") {
        this.$db.collection('users')
        .where('partners', 'array-contains', this.$store.state.user.partners[0])
        .onSnapshot(snapshot => {
          if (snapshot.size) {
            snapshot.forEach(doc => {
              users.push({_id: doc.id, ...doc.data()})
            })
          }
        })
      }
      this.users = users
    }
  },

  filters: {
    
  },

  created() {
    const waitForAccountDetails = setInterval(() => {
      if (this.$store.state.user.userType) {
        this.getUsers()
        clearInterval(waitForAccountDetails)
      }
    }, 50)
  },
  mounted() {

  },
  updated() {
    
  },
})
